import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TitleBar from "../titleBar";
import Box from "../box";
import { getLocalStateValue } from "../../../utils/helpers";
import InfoModal from "../infoModal";

// image imports
import IsolationTwentythree from "../../../assets/isolation/isolation_twentythree.png"
import IsolationTwentyfour from "../../../assets/isolation/isolation_twentyfour.png"
import IsolationTwentyfive from "../../../assets/isolation/isolation_twentyfive.png"
import IsolationTwentysix from "../../../assets/isolation/isolation_twentysix.png"
import IsolationTwentyseven from "../../../assets/isolation/isolation_twentyseven.png"

type VentilatieProps = {
    globals?: {
        colors: {
            default: ""
        }
    },
    pageData?: {
        back_text: string,
        title: string,
        description: string,
        next_url: string,
        prev_url: string
    },
    updateAnswer?: (title: string, answer: string, url?: string) => void,
    storeAnswer?: (data: any, key: string) => void,
    modalInformation?: any
}

const Ventilatie = ({ globals, pageData, updateAnswer = () => {}, storeAnswer = () => {}, modalInformation }: VentilatieProps) => {
    const [ hoverState, setHoverState ] = useState(0);
    const [ activeBox, setActiveBox ] = useState("");
    const [ modalState, setModalState ] = useState(false);

    const localStatVloer = getLocalStateValue("20");

    const navigate = useNavigate();

    useEffect(() => {
        const localState = getLocalStateValue("21");

        if (localState) {
            setActiveBox(localState.answerNo);
        }
    }, [])

    const goBack = () => {
        if(localStatVloer.answerNo == 0){
            navigate("/vraag/vloerisolatie")
        }else{
            navigate(pageData?.prev_url || "")
        }
    }
    
    const getImage = (answerIndex?: string) => {
        switch(answerIndex) {
            case "0":
                return IsolationTwentythree;
            case "1":
                return IsolationTwentyfour;
            case "2":
                return IsolationTwentyfive;
            case "3":
                return IsolationTwentysix;
            case "4":
                return IsolationTwentyseven;
        }
    }

    const onClick = (answer?: string, answerIndex?: string) => {
        const question = "ventilatie";
        updateAnswer(question || "", answer || "", pageData?.next_url);
        storeAnswer({"answerNo": answerIndex, "ventilatie": answer, image: getImage(answerIndex)}, "21");
    }

    const openInformationModal = () => {
        setModalState(true);
    }

    return(
        <div className = "w-full flex justify-center box-border">
            <div className = "container mx-auto flex-col justify-center box-border px-[16px] md:px-16 lg:px-32">
                <TitleBar back_text = {localStatVloer.answerNo == 0 ? "Vloerisolatie" :pageData?.back_text} infoColor = {globals?.colors?.default} title = {pageData?.title} description = {pageData?.description} goBack = {goBack} openInfoModal={openInformationModal} />
                <div className = "flex flex-col w-full mt-[10px] mb-[100px]">
                    <div className = "flex w-full flex-col md:flex-row border-b-[1px] border-b-[#F0F5F5]">
                        <Box flex = {1} hasRightBorder text = "Natuurlijke ventilatie" hoverValue = {1} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {IsolationTwentythree} answerIndex = "0" isActive = {activeBox === "0"} />
                        <Box flex = {1} hasRightBorder text = "Natuurlijk met raamroosters" hoverValue = {2} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {IsolationTwentyfour} answerIndex = "1" isActive = {activeBox === "1"} />
                        <Box flex = {1} hasRightBorder text = "Minimaal mechanisch (C) geïsoleerd" hoverValue = {3} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {IsolationTwentyfive} answerIndex = "2" isActive = {activeBox === "2"} />
                        <Box flex = {1} hasRightBorder text = "Vraaggestuurd mechanisch (C)" hoverValue = {4} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {IsolationTwentysix} answerIndex = "3" isActive = {activeBox === "3"} />
                    </div>
                    <div className = "flex w-full flex-col md:flex-row">
                        <Box flex = {1} hasRightBorder text = "Balansventilatie met warmterecuperatie (D)" hoverValue = {5} hoverState = {hoverState} onHoverEvent = {setHoverState} color = {globals?.colors?.default} onRoute = {onClick} image = {IsolationTwentyseven} answerIndex = "4" isActive = {activeBox === "4"} />
                        <div className = "flex flex-1 box-border px-[15px]" />
                        <div className = "flex flex-1 box-border px-[15px]" />
                        <div className = "flex flex-1 box-border px-[15px]" />
                    </div>
                </div>
            </div>
            <InfoModal modalInformation = {modalInformation} isModalOpen = {modalState} closeModal = {() => setModalState(false)} />
        </div>
    )
}

export default Ventilatie;